// CourseStoreDetail.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import './CourseDetail.css';
import Header from '../../components/Headers/Header.jsx';

import { CourseStoreDetailInfoItem, CourseStoreDetailSubject } from "./components";
import { ImageWithFallback } from "../../components/ImageWithFallback";
import { courseFallBack } from "../../helpers/shared";
import coursesStore from "../../store/CourseStore";
import { observer } from "mobx-react-lite";
import CartBtn from "../../components/CartBtn/CartBtn";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner.jsx"; // Кастомный спиннер

// TODO: вынести в одно место, когда устаканятся варианты экзаменов
const classLocalization = {
    9: 'ОГЭ',
    11: 'ЕГЭ'
}

const CourseDetail = observer(() => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [course, setCourse] = useState(null);


    const handleCourseClick = (courseId) => {
        navigate(`/courses-options/${courseId}`);
    };

    const allCourses = coursesStore.data

    useEffect(() => {
        if (allCourses !== null) return
        coursesStore.fetchAllCoursesData();
    }, []);

    useEffect(() => {
        if (id === undefined || id === null) return

        setCourse(allCourses?.find(({ id: courseId }) => courseId === id) ?? null)
    }, [id, allCourses]);

    if (!course) return <LoadingSpinner />; {/* Заменяем стандартную загрузку на кастомную */ };

    return (
        <div className='VideoCard overflow-hidden h-100 break-p-1200:scrollbar-none scrollbar'>
            <div className="p">
                <Header />
            </div>

            <div class='flex flex-col break-p-1200:flex-row break-p-1200:justify-between break-p-1200:mt-[55px] mt-[0px]'>
                <div className='infoSection flex flex-col sm:order-1'>
                    <div className=' mb-[0px] order-1'>
                        <h1>{course.title}</h1>
                    </div>


                    <div className='flex gap-1 order-2 break-p-1200:mb-[0px] mb-[22px]'>
                        {course.subject &&
                            <CourseStoreDetailSubject
                                className='bg-lavender text-white'
                                content={course.subject.toLowerCase()}
                            />
                        }

                        {classLocalization[course.class_course] && <CourseStoreDetailSubject
                            className='border-2 border-solid border-sub-title text-sub-title'
                            content={classLocalization[course.class_course]} />}
                    </div>

                    <div class='mt-[40px] mb-[20px] break-p-1200:mb-[70px] text-sub-title dark:text-white text-[24px] order-4 '> {course.description}</div>

                    <div class='flex gap-[13px] break-p-1200:gap-[65px] align-bottom mb-[45px] break-p-1200:mb-[95px] order-5 break-p-1200:flex-nowrap flex-wrap' >

                        {/*// TODO: занести похожие свг в одно место */}
                        <CourseStoreDetailInfoItem image={<svg class='stroke-sub-title dark:stroke-white' width='40' height='40' viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8.75 5H32.0833M8.75 35H32.0833M29.1667 5V9.41205C29.1667 10.5624 28.77 11.6775 28.0436 12.5695L23.2518 18.4533C22.4036 19.4948 22.4238 20.9657 23.3002 21.9853L27.9582 27.4038C28.7379 28.3108 29.1667 29.4672 29.1667 30.6632V35M11.6667 5V9.41205C11.6667 10.5624 12.0633 11.6775 12.7897 12.5695L17.5815 18.4533C18.4297 19.4948 18.4096 20.9657 17.5331 21.9853L12.8751 27.4038C12.0954 28.3108 11.6667 29.4672 11.6667 30.6632V35"
                                strokeWidth="3.33333" strokeLinecap="round"
                                strokeLinejoin="round" />
                        </svg>} title="Длительность: 6 месяцев" />

                        <CourseStoreDetailInfoItem image={<svg class='stroke-sub-title dark:stroke-white' width='40' height='40' viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12.2187 12.6905H29.0832M11.4584 3.33317V6.38584M11.4584 6.38584L29.1662 6.38551M11.4584 6.38584C8.5244 6.38584 6.14619 8.80522 6.14633 11.79L6.14715 29.804C6.14729 32.7886 8.52567 35.208 11.4595 35.208H29.1673C32.1013 35.208 34.4798 32.7883 34.4797 29.8035L34.4788 11.7895C34.4787 8.80491 32.1001 6.38551 29.1662 6.38551M29.1662 3.33301V6.38551M16.7721 28.9031V18.0946L13.2305 20.7967M26.5114 28.9031V18.0946L22.9698 20.7967"
                                strokeWidth="3.33333" strokeLinecap="round"
                                strokeLinejoin="round" />
                        </svg>} title="Старт в декабре" />
                    </div>



                    <div class='flex gap-[49px] items-center order-6 flex-wrap-reverse break-p-1200:flex-nowrap'>
                        <button
                            className="bg-scrollbarThumbActive text-[24px] px-[35px] py-[16px] text-white flex items-start justify-center rounded-[20px] transition-all duration-150 ease-in-out transform hover:scale-98 hover:bg-scrollbarThumbHover active:scale-95 sm:mx-0  text-nowrap sm:px-[58px] sm:py-[23px]"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleCourseClick(course.id);
                            }}>
                            выбрать тариф
                        </button>

                        {/*// TODO: вынести прайс в shared */}
                        {Boolean(course.price) && <div class='flex flex-nowrap'>
                            <div
                                className='text-[32px] font-semibold text-sub-title text-nowrap dark:text-white'>от {course.price.toLocaleString('ru-RU')} ₽</div>
                            <div className='text-[32px] font-semibold text-light-gray text-nowrap'>/ мес</div>
                        </div>}
                    </div>

                    <div className="relative w-full max-w-[600px] max-h-[300px] h-auto break-p-1200:order-3 order-2 break-p-1200:hidden block">
                        <ImageWithFallback
                            className="rounded-[20px] w-full h-auto object-cover object-right"
                            src={require(`../../assets/${course.id}.png`)}
                            alt="Image"
                            fallbackSrc={courseFallBack}
                        />
                    </div>
                </div>

                {/*// TODO: сделать превью для видео? */}
                <div className="relative w-full max-w-full break-p-1200:block hidden order-2 break-p-1200:order-2 ml-3">
                    <ImageWithFallback className=" absolute inset-0 rounded-[20px]  w-full h-auto object-contain mx-auto " src={course.image_url} alt="Image" fallbackSrc={courseFallBack} />
                </div>
            </div>

            <CartBtn />
        </div>
    );
});

export default CourseDetail;
